import * as React from "react";
import { EDogSex, GetCountriesReferentialQuery, ReferentialApi } from "../../../api";
import { useTl } from "../../../hooks";

import { ETLCodes } from "../../../locales";
import { FusionRadio } from "../components/FusionRadio";
import { FusionCombo } from "../components/FusionCombo";
import { FusionCheckbox } from "../components/FusionCheckbox";
import { FieldSet } from "nsitools-react";
import { useGlobalData } from "../../../contexts";

export interface IDogFusionProps {
  dog1: any;
  dog2: any;
  selectLeft?: boolean;
}

export const DogFusion: React.FunctionComponent<IDogFusionProps> = ({ dog1, dog2, selectLeft = null }) => {
  const { t } = useTl();
  const { currentLanguage } = useGlobalData();

  return (
    <>
      <FieldSet title={t(ETLCodes.DogInformations)}>
        {/*DogType*/}
        <FusionCombo
          elementName="dog1.dogTypeId"
          elementNameBis="dog2.dogTypeId"
          fusedElementName="fusion.fusedDog.dogTypeId"
          label={ETLCodes.Type}
          elementValue={dog1.dogTypeId}
          elementValueBis={dog2.dogTypeId}
          referentialFunc={(refApi: ReferentialApi) => refApi.getDogTypes(currentLanguage.languageId)}
          selectLeft={selectLeft}
        />
        {/*Name*/}
        <FusionRadio
          elementName="dog1.firstName"
          elementNameBis="dog2.firstName"
          fusedElementName="fusion.fusedDog.firstName"
          label={ETLCodes.Name}
          elementValue={dog1.firstName}
          elementValueBis={dog2.firstName}
          selectLeft={selectLeft}
        />
        {/*Birthdate*/}
        <FusionRadio
          elementName="dog1.birthDate"
          elementNameBis="dog2.birthDate"
          fusedElementName="fusion.fusedDog.birthDate"
          label={ETLCodes.BirthDate}
          elementValue={dog1.birthDate}
          elementValueBis={dog2.birthDate}
          isDate
          selectLeft={selectLeft}
        />
        {/*Deathdate*/}
        <FusionRadio
          elementName="dog1.deathDate"
          elementNameBis="dog2.deathDate"
          fusedElementName="fusion.fusedDog.deathDate"
          label={ETLCodes.DeathDate}
          elementValue={dog1.deathDate}
          elementValueBis={dog2.deathDate}
          isDate
          selectLeft={selectLeft}
        />
        {/*Breed*/}
        <FusionCombo
          elementName="dog1.breedId"
          elementNameBis="dog2.breedId"
          fusedElementName="fusion.fusedDog.breedId"
          label={ETLCodes.Breed}
          elementValue={dog1.breedId}
          elementValueBis={dog2.breedId}
          referentialFunc={(refApi: ReferentialApi) => refApi.getBreeds(null)}
          selectLeft={selectLeft}
        />
        {/*Color*/}
        <FusionCombo
          elementName="dog1.colorId"
          elementNameBis="dog2.colorId"
          fusedElementName="fusion.fusedDog.colorId"
          label={ETLCodes.Color}
          elementValue={dog1.colorId}
          elementValueBis={dog2.colorId}
          referentialFunc={(refApi: ReferentialApi) => refApi.getColors(currentLanguage.languageId)}
          selectLeft={selectLeft}
        />
        {/*Sex*/}
        <FusionCombo
          elementName="dog1.sex"
          elementNameBis="dog2.sex"
          fusedElementName="fusion.fusedDog.sex"
          label={ETLCodes.Sex}
          elementValue={dog1.sex}
          elementValueBis={dog2.sex}
          referentialFunc={(refApi: ReferentialApi) => refApi.getSex(currentLanguage.languageId)}
          selectLeft={selectLeft}
        />
        {/*Country*/}
        <FusionCombo
          elementName="dog1.countryId"
          elementNameBis="dog2.countryId"
          fusedElementName="fusion.fusedDog.countryId"
          label={ETLCodes.Country}
          elementValue={dog1.countryId}
          elementValueBis={dog2.countryId}
          referentialFunc={(refApi: ReferentialApi) => refApi.getCountries(new GetCountriesReferentialQuery())}
          selectLeft={selectLeft}
        />
        {/*Prefix*/}
        <FusionRadio
          elementName="dog1.pedigreePrefix"
          elementNameBis="dog2.pedigreePrefix"
          fusedElementName="fusion.fusedDog.pedigreePrefix"
          label={ETLCodes.Prefix}
          elementValue={dog1.pedigreePrefix}
          elementValueBis={dog2.pedigreePrefix}
          selectLeft={selectLeft}
        />
        {/*Pedigree Number*/}
        <FusionRadio
          elementName="dog1.identifier"
          elementNameBis="dog2.identifier"
          fusedElementName="fusion.fusedDog.identifier"
          label={ETLCodes.PedigreeNo}
          elementValue={dog1.identifier}
          elementValueBis={dog2.identifier}
          selectLeft={selectLeft}
        />
        {/*Validation*/}
        <FusionCheckbox
          elementName="dog1.awaitingValidation"
          elementNameBis="dog2.awaitingValidation"
          fusedElementName="fusion.fusedDog.awaitingValidation"
          label={ETLCodes.AwaitingValidation}
          elementValue={dog1.awaitingValidation}
          elementValueBis={dog2.awaitingValidation}
          selectLeft={selectLeft}
        />
        {/*Tatoo*/}
        <FusionRadio
          elementName="dog1.tatoo"
          elementNameBis="dog2.tatoo"
          fusedElementName="fusion.fusedDog.tatoo"
          label={ETLCodes.Tatoo}
          elementValue={dog1.tatoo}
          elementValueBis={dog2.tatoo}
          selectLeft={selectLeft}
        />
        {/*Remark*/}
        <FusionRadio
          elementName="dog1.remark"
          elementNameBis="dog2.remark"
          fusedElementName="fusion.fusedDog.remark"
          label={ETLCodes.Remark}
          elementValue={dog1.remark}
          elementValueBis={dog2.remark}
          selectLeft={selectLeft}
        />
        {/*sharepoint*/}
        {!!dog1.sharepointUri && !!dog2.sharepointUri ? (
          <FusionCheckbox
            elementName="dog1.sharepointUri"
            elementNameBis="dog2.sharepointUri"
            fusedElementName="fusion.fusedDog.sharepointUri"
            label={ETLCodes.SharePoint}
            elementValue={dog1.sharepointUri}
            elementValueBis={dog2.sharepointUri}
            selectLeft={selectLeft}
          />
        ) : null}
      </FieldSet>
      <FieldSet title={t(ETLCodes.ParentInformations)}>
        {/*UnknownMother*/}
        <FusionCheckbox
          elementName="dog1.unknownMother"
          elementNameBis="dog2.unknownMother"
          fusedElementName="fusion.fusedDog.unknownMother"
          label={ETLCodes.UnknownMother}
          elementValue={dog1.unknownMother}
          elementValueBis={dog2.unknownMother}
          selectLeft={selectLeft}
        />
        {/*Mother*/}
        <FusionRadio
          elementName="dog1.motherDogId"
          elementNameBis="dog2.motherDogId"
          fusedElementName="fusion.fusedDog.motherDogId"
          label={ETLCodes.Mother}
          elementValue={dog1.motherDogId}
          elementValueBis={dog2.motherDogId}
          sex={EDogSex.Female}
          selectLeft={selectLeft}
        />
        {/*UnknownFather*/}
        <FusionCheckbox
          elementName="dog1.unknownFather"
          elementNameBis="dog2.unknownFather"
          fusedElementName="fusion.fusedDog.unknownFather"
          label={ETLCodes.UnknownFather}
          elementValue={dog1.unknownFather}
          elementValueBis={dog2.unknownFather}
          selectLeft={selectLeft}
        />
        {/*Father*/}
        <FusionRadio
          elementName="dog1.fatherDogId"
          elementNameBis="dog2.fatherDogId"
          fusedElementName="fusion.fusedDog.fatherDogId"
          label={ETLCodes.Father}
          elementValue={dog1.fatherDogId}
          elementValueBis={dog2.fatherDogId}
          sex={EDogSex.Male}
          selectLeft={selectLeft}
        />
      </FieldSet>
      <FieldSet title={t(ETLCodes.OtherInformations)}>
        {/*Cut Tail*/}
        <FusionCheckbox
          elementName="dog1.dockedTail"
          elementNameBis="dog2.dockedTail"
          fusedElementName="fusion.fusedDog.dockedTail"
          label={ETLCodes.DockedTail}
          elementValue={dog1.dockedTail}
          elementValueBis={dog2.dockedTail}
          selectLeft={selectLeft}
        />
        {/*Internal Number*/}
        <FusionRadio
          elementName="dog1.internalNumber"
          elementNameBis="dog2.internalNumber"
          fusedElementName="fusion.fusedDog.internalNumber"
          label={ETLCodes.InternalNumber}
          elementValue={dog1.internalNumber}
          elementValueBis={dog2.internalNumber}
          selectLeft={selectLeft}
        />
        {/*Social*/}
        <FusionCheckbox
          elementName="dog1.socialBehaviour"
          elementNameBis="dog2.socialBehaviour"
          fusedElementName="fusion.fusedDog.socialBehaviour"
          label={ETLCodes.SocialBehaviour}
          elementValue={dog1.socialBehaviour}
          elementValueBis={dog2.socialBehaviour}
          selectLeft={selectLeft}
        />
        {/*Breeding*/}
        <FusionCheckbox
          elementName="dog1.breedingAuthorized"
          elementNameBis="dog2.breedingAuthorized"
          fusedElementName="fusion.fusedDog.breedingAuthorized"
          label={ETLCodes.BreedingAuthorized}
          elementValue={dog1.breedingAuthorized}
          elementValueBis={dog2.breedingAuthorized}
          selectLeft={selectLeft}
        />
        {/*Workbook*/}
        <FusionCheckbox
          elementName="dog1.workCertificate"
          elementNameBis="dog2.workCertificate"
          fusedElementName="fusion.fusedDog.workCertificate"
          label={ETLCodes.WorkCertificate}
          elementValue={dog1.workCertificate}
          elementValueBis={dog2.workCertificate}
          selectLeft={selectLeft}
        />
        {/*ExclusionDate*/}
        <FusionRadio
          elementName="dog1.exclusionStartDate"
          elementNameBis="dog2.exclusionStartDate"
          fusedElementName="fusion.fusedDog.exclusionStartDate"
          label={ETLCodes.ExclusionStartDate}
          elementValue={dog1.exclusionStartDate}
          elementValueBis={dog2.exclusionStartDate}
          selectLeft={selectLeft}
          isDate
        />
        {/*ExclusionDate*/}
        <FusionRadio
          elementName="dog1.exclusionEndDate"
          elementNameBis="dog2.exclusionEndDate"
          fusedElementName="fusion.fusedDog.exclusionEndDate"
          label={ETLCodes.ExclusionEndDate}
          elementValue={dog1.exclusionEndDate}
          elementValueBis={dog2.exclusionEndDate}
          selectLeft={selectLeft}
        />
        {/*Exclusion reason*/}
        <FusionRadio
          elementName="dog1.exclusionReason"
          elementNameBis="dog2.exclusionReason"
          fusedElementName="fusion.fusedDog.exclusionReason"
          label={ETLCodes.ExclusionReason}
          elementValue={dog1.exclusionReason}
          elementValueBis={dog2.exclusionReason}
          selectLeft={selectLeft}
        />
        {/*Number of tries*/}
        <FusionRadio
          elementName="dog1.numberOfImportTries"
          elementNameBis="dog2.numberOfImportTries"
          fusedElementName="fusion.fusedDog.numberOfImportTries"
          label={ETLCodes.AmountTries}
          elementValue={dog1.numberOfImportTries}
          elementValueBis={dog2.numberOfImportTries}
          selectLeft={selectLeft}
        />
      </FieldSet>
    </>
  );
};
